/* **************************************************************************
 *
 *  WARNING: DO NOT RENAME -> ENUMS MUST BE KEPT IN SYNC WITH POSTHOG
 *
 * ***************************************************************************/

export enum PostHogEventsEnum {
    CompanionEnergyMetersEditAttachmentUploaded = 'CompanionEnergyMetersEditAttachmentUploaded',
    CompanionEnergyMetersEditManual = 'CompanionEnergyMetersEditManual',
    CompanionEnergyMetersConfirmed = 'CompanionEnergyMetersConfirmed',
    CompanionToggleWaterAndEnergy = 'Companion Toggle Water And Energy',
    CompanionSearchTransaction = 'Companion Search Transaction',
    CompanionConfirmWaterMeterReadings = 'Companion Confirm Water Meter Readings',
    CompanionDeletePicture = 'Companion Delete Picture',
    CompanionClickListViewTransactionIcon = 'Companion Click List View Transaction Icon',
    CompanionClickListViewTransactionDetails = 'Companion Click List View Transaction Details',

    DesktopEnergyMetersEditAttachmentUploaded = 'DesktopEnergyMetersEditAttachmentUploaded',
    DesktopEnergyMetersEditManual = 'DesktopEnergyMetersEditManual',
    DesktopEnergyMetersConfirmed = 'DesktopEnergyMetersConfirmed',

    /** Nps review */
    SubmitHousematchReview = 'Submit Housematch Review',

    /** Water Transfer */
    SaveWaterHandling = 'Save Water Handling',
    UpdateTransferDate = 'Update Transfer Date',
    SaveOnlyWaterInfo = 'Save Only Water Info',
    SaveAndConfirmWaterInfo = 'Save and Confirm Water Info',
    ConfirmOnlyWaterInfo = 'Confirm Only Water Info',
    SaveWaterSupplier = 'Save Water Supplier',

    /** Services **/
    ClickService = 'Click Service',
    ViewLineup = 'View Line-up',
    ClickChooseOffer = 'Click Choose Offer',
    ClickChangeOffer = 'Click Change Offer',
    ClickNewSimulation = 'Click New Simulation',
    ClickNextOrderInfo = 'Click Next Order Info',
    ClickNextFulfillment = 'Click Next Fulfillment',
    ClickChangeFulfillment = 'Click Change Fulfillment',
    ClickNextTransactionDetails = 'Click Next Transaction Details',
    ClickNextContactDetails = 'Click Next Contact Details',
    ConfirmOffer = 'Confirm Offer',
    ClickUpsellService = 'Click Upsell Service',
    ClickDone = 'Click Done',
    ViewContactDetails = 'View Contact Details',
    ViewTransactionDetails = 'View Transaction Details',
    ViewService = 'View Service',
    SaveMeterReadings = 'Save Meter Readings',
    GenerateWaterTransferDoc = 'Generate Water Transfer Doc',
    SaveNationalRegistrationNumber = 'Save National Registration Number',

    /** Meter readings **/
    ViewMeterReadings = 'View Meter Readings',

    /** Contact us **/
    ClickContactUs = 'Click Contact Us',

    /** Leaver Dashboard */
    ViewChangeDateModal = 'View Change Date Modal',
    ClickGeneralHelp = 'Click General Help',
    ViewDashboard = 'View Dashboard',
    EditMeterReadings = 'Edit Meter Readings',
    ClickMeterReadings = 'Click Meter Readings', // Not available yet
    SaveEnergySuppliers = 'Save Energy Suppliers',
    ClickAddSuppliers = 'Click Add Suppliers',
    ClickEnergyFinalInvoice = 'Click Energy Final Invoice',
    ClickEnergySuppliers = 'Click Energy Suppliers', // Not available yet
    ClickDedicatedHelp = 'Click Dedicated Help',
    SaveServiceHandling = 'Save Service Handling',
    ClickShoppingCart = 'Click Shopping Cart',
    SubmittedTransfer = 'Submitted Transfer',
    ClickIDoNotNeedHelp = 'Click I Do Not Need Help',
    ClickChangeFilingPreference = 'Click Change Filing Preference',
    ClickTransferSubmissionLink = 'Click Transfer Submission Link',

    ClickOnDocumentation = 'Click On Documentation',

    /** Telecom **/
    ClickFinishingTelecom = 'Click Finishing Telecom',

    /** REAL ESTATE AGENT DASHBOARD */
    ClickSimulateEnergyProposal = 'Click Simulate Energy Proposal',
    ClickNewVacancyContract = 'Click New Vacancy Contract ',
    ClickSendQuickProposal = 'Click Send Quick Proposal',
    ClickStartEnergyOptimization = 'Click Start Energy Optimization',
    ClickToDos = 'Click To Dos',
    ClickStatus = 'Click Status',
    ClickToLeaver = 'Click to Leaver',
    ClickToTransferee = 'Click to Transferee',
    ViewHousematchInsights = 'View Housematch Insights',
    TakeActionOnHousematchReview = 'Take Action on Housematch Review',
    ClickReviews = 'Click Reviews',
    ClickNumbers = 'Click Numbers',
    ClickEditTransactionDetails = 'Click Edit Transaction Details',
    SaveTransactionDetails = 'Save Transaction Details',
}

export enum PosthogFrom {
    Admin = 'Admin',
    AdminTransferee = 'Admin - Transferee detail',
    AdminLeaver = 'Admin - Leaver detail',
    RealEstateAgentDashboard = 'REA Dashboard',
    LeaverDashboard = 'Leaver Dashboard',
    TransfereeDashboard = 'Transferee Dashboard',
}
